export default __webpack_public_path__ + "static/media/hp web.78857d62.png";